import { InjectionToken } from '@angular/core';

/**
 * Injection token for providing the external vehicle lookup image.
 */
export const EXTERNAL_VEHICLE_LOOKUP_LOGO_TOKEN = new InjectionToken<string>('EXTERNAL_VEHICLE_LOOKUP_LOGO');

/**
 * Injection token for providing the external vehicle lookup name.
 */
export const EXTERNAL_VEHICLE_LOOKUP_NAME_TOKEN = new InjectionToken<string>('EXTERNAL_VEHICLE_LOOKUP_NAME');

/**
 * Whether a vehicle specification lookup may be issued without a user asking. Defaults to false so
 * an app that has not declared it never spends money unprompted.
 */
export const VEHICLE_SPECIFICATION_AUTO_FETCH_TOKEN = new InjectionToken<boolean>('VEHICLE_SPECIFICATION_AUTO_FETCH', {
    providedIn: 'root',
    factory: () => false,
});
